export default __webpack_public_path__ + "static/media/Standard15.9cea103b.png";